export const version = "hash/5.0.2";
//# sourceMappingURL=_version.js.map